import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LoadingOverlay } from 'site-modules/shared/components/loading-spinner/loading-overlay';

export function LoadingSpinner({ children = null, isLoading = false, classes = '' }) {
  return (
    <div className={classNames('loading-container pos-r', classes)}>
      {isLoading && <LoadingOverlay />}
      {children}
    </div>
  );
}

LoadingSpinner.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  classes: PropTypes.string,
};
